module.exports = __webpack_public_path__ + "ui-static/img/logo2_white.1d8004ff.svg";